(function (Drupal, $, settings) {
  //Add active class to term menu
  if ($('.path-taxonomy').length) {
    var path = window.location.pathname;

    if (path) {
      var splitPath = path.split('/');

      if (splitPath.length > 0) {
        if (splitPath[1] === 'menu') {
          $('.views-content a[href="' + path + '"]').addClass('is-active');
        }
      }
    }
  }

  //Trust Center sidebar menu: TXRH-11225
  if ($('.block-menu-system-menu-blocktrust-center-menu').length && window.innerWidth >= 992) {
    var $element = $('.block-menu-system-menu-blocktrust-center-menu');
    var elementInitialOffsetTop = $element.offset().top;

    $(window).scroll(function() {
      // Replace with your element's ID or selector
      var elementOffsetTop = $element.offset().top; // Re-evaluate if element position can change
      var windowScrollTop = $(window).scrollTop();

      if (windowScrollTop >= elementOffsetTop - 60) {
        // The element has reached or passed the top of the browser viewport
        // You can add your desired actions here, e.g.,
        $element.addClass('fixed-position');
      }
      if (windowScrollTop <= elementInitialOffsetTop + 120) {
        $element.removeClass('fixed-position');
      }
    });
  }

  if ($('.block-menu-system-menu-blocktrust-center-menu').length && window.innerWidth <= 991) {
    $('.block-menu-system-menu-blocktrust-center-menu').append('<button class="back-to-top hidden"><svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_16804_8259)"><circle cx="21.7139" cy="21.7139" r="16" transform="rotate(-90 21.7139 21.7139)" fill="#FFCC00"/></g><path d="M16.2834 23.6338L21.714 18.2032L27.1445 23.6338" stroke="#111111" stroke-width="2.688" stroke-linecap="round"/><defs><filter id="filter0_d_16804_8259" x="-0.000418186" y="-0.000418186" width="43.4286" height="43.4286" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset/><feGaussianBlur stdDeviation="2.85714"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_16804_8259"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_16804_8259" result="shape"/></filter></defs></svg></button>');
    var windowScrollTop = $(window).scrollTop();

    if (windowScrollTop > 50) {
      $('.block-menu-system-menu-blocktrust-center-menu button').fadeIn();
    }

    $(window).scroll(function() {
      windowScrollTop = $(window).scrollTop();

      if (windowScrollTop > 50) {
        $('.block-menu-system-menu-blocktrust-center-menu button').fadeIn();
      }
      else {
        $('.block-menu-system-menu-blocktrust-center-menu button').fadeOut();
      }
    });

    $('.block-menu-system-menu-blocktrust-center-menu button').click(function() {
      $('html, body').animate({
        scrollTop: 0
      }, 500); // Animates the scroll to the top over 800 milliseconds
    });

  }
})(Drupal, jQuery);
